export const DRAWER_WIDTH: number = 360 as const